import _ from 'lodash'

export default () => {
  return {
    template: '#template__newstile',
    props: {
      title: String,
      date: String,
      category: String,
      link: String
    },
    computed: {
      hasmeta () {
        return !_.isNil(this.date) || !_.isNil(this.category)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/newstile.js